import type {IStateMachine} from 'src/types/StateMachine';
import {ApiEndpoints} from 'src/shared/constants/apiEndpoints';
import {
  complianceEventApiClient,
  courseClassroomApiClient,
  formApiClient,
  itemAssignmentApiClient,
  safetyEventApiClient,
  taskAssignmentApiClient,
  taskDefinitionApiClient,
} from 'src/api/ProactApiClientInstances';
import {formStateMachineQueryFn} from 'src/app/forms/offline/reads';
import {
  isTaskStateMachineUrl,
  taskStateMachineQueryFn,
} from 'src/app/tasks/offline/reads';
import {emptySplitApi} from '../api';

async function fetchStateMachineByUrl(url: string): Promise<IStateMachine> {
  switch (url) {
    case ApiEndpoints.getTaskDefinitionStateMachine:
      return (await taskDefinitionApiClient.getDefinitionStateMachine()) as unknown as IStateMachine;
    case ApiEndpoints.getTaskAssignmentStateMachine:
      return (await taskAssignmentApiClient.getAssignmentStateMachine()) as unknown as IStateMachine;
    case ApiEndpoints.getCourseClassroomStateMachine:
      return (await courseClassroomApiClient.getStateMachine()) as unknown as IStateMachine;
    case ApiEndpoints.getSafetyEventStateMachine:
      return (await safetyEventApiClient.getStateMachine()) as unknown as IStateMachine;
    case ApiEndpoints.getComplianceEventStateMachine:
      return (await complianceEventApiClient.getStateMachine()) as unknown as IStateMachine;
    case ApiEndpoints.getItemAssignmentStateMachine:
      return (await itemAssignmentApiClient.getAssignmentStateMachine()) as unknown as IStateMachine;
    case `${ApiEndpoints.getStaticForm}/state-machine`:
      return (await formApiClient.getStateMachine()) as unknown as IStateMachine;
    default:
      throw new Error(
        `No typed client registered for state machine URL: ${url}`
      );
  }
}

const formsStateMachine = formStateMachineQueryFn(fetchStateMachineByUrl);
const tasksStateMachine = taskStateMachineQueryFn(fetchStateMachineByUrl);

export const stateMachineApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getStateMachine: builder.query<IStateMachine, string>({
      queryFn: url =>
        isTaskStateMachineUrl(url)
          ? tasksStateMachine(url)
          : formsStateMachine(url),
      providesTags: (_result, _err, arg) => [{type: 'StateMachines', id: arg}],
    }),
  }),
});

export const {useGetStateMachineQuery} = stateMachineApi;
